type LegendChipProps = {
    backgroundColor?: string,
    backgroundImage?: string,
    color?: string,
    caption: string
}

export function LegendChip({ caption, backgroundColor = "white", color = "black", backgroundImage }: LegendChipProps) {
    return (
        <div className="legend-chip-div" style={{ backgroundColor, color, backgroundImage }}>
            {caption}
        </div>
    )
}
